import React, { Component } from "react";
import constants from "../../constants";
import axios from "axios";
// import {GoogleApiWrapper, Map, Marker, Omit} from 'google-maps-react'
import {GoogleMap} from 'react-google-maps'

class LoginView extends Component {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.state = { error: false };
  }

  componentWillMount() {
    delete localStorage.token;
    delete localStorage.establishment_img;
    delete localStorage.establishment_name;
  }

  handleSubmit(event) {
    event.preventDefault();

    const email = this.refs.email.value;
    const password = this.refs.password.value;
    const signinUrl = constants().URL_SERVICE + "account/manager/login/";

    axios
      .post(signinUrl, {
        email,
        password
      })
      .then(response => {
        localStorage.setItem("token", response.data.token);
        localStorage.setItem("establishment_name", response.data.estab_name);
        localStorage.setItem("establishment_img", response.data.estab_picture ? response.data.estab_picture : "");
        localStorage.setItem("latitude", response.data.latitude);
        localStorage.setItem("longitude", response.data.longitude);
        localStorage.setItem("address", response.data.address);
        localStorage.setItem("is_super_user", response.data.is_superuser);
        localStorage.setItem("id_establishment", response.data.id);
        this.props.router.replace("/home/users");
      })
      .catch(error => this.setState({ error: true }));
  }

  render() {
    return (
      
       

      <div className="app app-header-fixed">
        <div className="container w-xxl w-auto-xs">
          <span className="navbar-brand block m-t">Allfast Admin</span>
          <div className="m-b-lg">
            <div className="wrapper text-center">
              <form
                name="form"
                className="form-validation"
                onSubmit={this.handleSubmit}
              >
                {this.state.error ? (
                  <div className="text-danger wrapper text-center">
                    Por favor, verifique seu usuário e senha.
                  </div>
                ) : (
                  ""
                )}

                <div className="list-group list-group-sm">
                  <div className="list-group-item">
                    <input
                      type="email"
                      placeholder="Email"
                      className="form-control no-border"
                      required
                      ref="email"
                    />
                  </div>
                  <div className="list-group-item">
                    <input
                      type="password"
                      placeholder="Senha"
                      className="form-control no-border"
                      required
                      ref="password"
                    />
                  </div>
                  <div className="text-right" onClick={()=> {this.props.router.replace("/forgotPassword");}}>
                    <a href="/#/forgotPassword/" className="text-muted">Esqueci minha senha</a>
                  </div>
                    
                </div>
                <button type="submit" className="btn btn-lg btn-block">
                  Entrar
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



export default LoginView



// WEBPACK FOOTER //
// ./src/views/Login/index.js